import { render, staticRenderFns } from "./PurPaymentList.vue?vue&type=template&id=6de5d302&scoped=true&"
import script from "./PurPaymentList.vue?vue&type=script&lang=js&"
export * from "./PurPaymentList.vue?vue&type=script&lang=js&"
import style0 from "./PurPaymentList.vue?vue&type=style&index=0&id=6de5d302&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5d302",
  null
  
)

export default component.exports